import React, {PureComponent} from 'react';
import Hammer from 'react-hammerjs';
import * as ReactGA from '../../GA';
import {ROUTES} from '../../routes';
import Menu from './Menu';
import TranslatedText from '../../atoms/TranslatedText';
import ScrollIcon from '../../atoms/ScrollIcon';
import videoBg from './cuts-glare-video.mp4';
import videoPoster from './cuts-glare-video-poster.jpg';
import i18n from '../../locales/i18n';

import './CutsGlare.css';
import './CutsGlareHowItWorks.css';
import Video from '../../atoms/Video';

export default class CutsGlareHowItWorks extends PureComponent {
    scrollableElement = React.createRef();

    componentDidMount() {
        this.scrollableElement.current.scrollTop = 2000;
        ReactGA.pageview(`${i18n.language}/HDPolarized/CutsGlare/HowItWorks`);
    }
    componentDidUpdate() {
        ReactGA.pageview(`${i18n.language}/HDPolarized/CutsGlare/HowItWorks`);
    }

    onSwipe = event => {
        if (event.direction === 2) {
            this.props.history.push(ROUTES.HDPOLARIZED_CUTSGLARE_AXIS);
        }
    };

    render() {
        const history = this.props.history;

        return (
            <Hammer onSwipe={this.onSwipe}>
                <article>
                    <div
                        ref={this.scrollableElement}
                        className="CutsGlare-container scrollable">
                        <div className="scroller">
                            <div className="scroller-top">
                                <h3 className="top-title">
                                    <TranslatedText tag="hdpolarized.cuts_glare.how_it_works.title" />
                                </h3>
                                <h4 className="top-subtitle">
                                    <TranslatedText tag="hdpolarized.cuts_glare.how_it_works.subTitle" />
                                </h4>
                            </div>
                            <div className="scroller-bottom">
                                <ScrollIcon tag="hdpolarized.cuts_glare.how_it_works.scroll" />
                                <h3 className="top-title">
                                    <TranslatedText tag="hdpolarized.cuts_glare.how_it_works.titleBottom" />
                                </h3>
                            </div>
                        </div>
                    </div>
                    <Menu active="how-it-works" history={history} />
                    <Video
                        className="CutsGlare-video"
                        src={videoBg}
                        poster="data:image/gif,AAAA"
                        style={{backgroundImage: `url(${videoPoster})`}}
                        autoPlay
                        muted
                        playsInline
                        loop
                    />
                </article>
            </Hammer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/hdpolarized/CutsGlareHowItWorks.js